export const refinancingCarLoanData = [
  {
    id: "step-one",
    stepName: "Review your existing auto loan",
  },
  {
    id: "step-two",
    stepName: "Determine the value of your car",
  },
  {
    id: "step-three",
    stepName: "Evaluate your credit",
  },
  {
    id: "step-four",
    stepName: "Gather information for your application",
  },
  {
    id: "step-five",
    stepName: "Compare lenders and rates",
  },

  {
    id: "step-six",
    stepName: "Apply to refinance your car loan",
  },
];

export const getRefinancingLoanData = [
  {
    id: 1,
    heading: "How Much Loan Can I Afford?",
    subHeading:
      "Estimate how much you can borrow based on your income, loan term, interest rate, and monthly expenses. This tool helps you assess your loan affordability and make informed borrowing decisions.",
    notice:
      "Minemi may partner with financial institutions and third-party providers to offer loan-related tools and services. While these partnerships help us maintain the platform, they do not influence our recommendations, which are unbiased and based solely on your input data. We encourage users to verify all loan details and consult with financial professionals as needed before making decisions. Terms and conditions may vary based on individual financial profiles and lender policies.",
    updationText: "Updated Oct 14, 2024 ·",
    updateTime: "3 min read",
  },
];
